import { TipsMapType } from '../index';

export const hotEventIssueFeedbackTips: TipsMapType = {
  en: 'Technical glitches and anomalies reported by players that disrupt normal gameplay.',
  zh: '玩家报告的、影响正常游玩的技术性故障与异常。',
};

export const hotEventGameExperienceTips: TipsMapType = {
  en: `Subjective evaluations and suggestions regarding the game's design—essentially, "is it fun?" and "is it well-made?"`,
  zh: '针对游戏本体设计的主观评价与建议，即"好不好玩、做得好不好"。',
};

export const hotEventMonetizationTips: TipsMapType = {
  en: `Feedback centered on spending and the value of purchases; the core focus is "value for money" and the "purchasing experience."`,
  zh: '一切围绕花钱与付费价值的声音，核心是"性价比与付费体验"。',
};

export const hotEventOperationsServiceTips: TipsMapType = {
  en: `Evaluations of the publisher's operational activities and service quality—essentially, "how well is the official team handling things?"`,
  zh: '对厂商运营动作与服务质量的评价，即"官方做事到不到位"。',
};

export const hotEventPlayerSentimentTips: TipsMapType = {
  en: `Emotional expressions and public discourse within the player community; the focus is on "prevailing trends and volume of discussion" rather than specific demands.`,
  zh: '玩家在社区层面的情绪表达与舆论传播，关注的是"风向与声量"而非具体诉求。',
};

export const hotEventComplianceRiskTips: TipsMapType = {
  en: `High-risk incidents extending beyond the game itself that involve legal regulations and brand reputation; these require the highest level of response.`,
  zh: '超出游戏本体、涉及法律监管与品牌信誉的高危事件，响应级别最高。',
};

export const hotEventClusterCategoriesTipsMap: {
  [key: string]: TipsMapType;
} = {
  game_experience: hotEventGameExperienceTips,
  operation_service: hotEventOperationsServiceTips,
  monetization: hotEventMonetizationTips,
  issue_feedback: hotEventIssueFeedbackTips,
  player_sentiment: hotEventPlayerSentimentTips,
  compliance_risk: hotEventComplianceRiskTips
};

export const hotEventPositiveTips: TipsMapType = {
  en: 'Highly discussed positive events identified by DataBrain through NLP clustering of comments based on selected criteria.',
  zh: 'DataBrain将筛选条件下的评论进行NLP聚类，得到的讨论度比较高的正面事件',
};

export const hotEventNegativeTips: TipsMapType = {
  en: 'Highly discussed negative events identified by DataBrain through NLP clustering of comments based on selected criteria.',
  zh: 'DataBrain将筛选条件下的评论进行NLP聚类，得到的讨论度比较高的负面事件',
};

export const hotEventNeutralTips: TipsMapType = {
  en: 'Highly discussed neutral events identified by DataBrain through NLP clustering of comments based on selected criteria.',
  zh: 'DataBrain将筛选条件下的评论进行NLP聚类，得到的讨论度比较高的中性事件',
};